<template>
    <v-main>
        <v-container>
            <v-row>
                <v-col>
                    <v-text-field dense v-model="plcnt" type="number" outlined  @input="CPools(teams)" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="4" v-for="pl in pools" >
                    <v-list dense v-for="t in pl">
                        <v-list-item>
                            <v-list-item-title>{{t.seed}} {{t.team}}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    {{pl.length}} teams
                    <v-card v-for="(p,i) in Pool(pl)">
                        <v-card-title class="subtitle-1">{{i+1}}</v-card-title>
                        <v-card-text >
                            <v-row>
                                <v-col cols="12" class="">
                                    {{p[0]}} {{pl[p[0]-1].team}} ({{pl[p[0]-1].seed}}) <span class="subtitle-2 pl-1">vs.</span> <input  class="float-right" style="border: solid thin #888888;width:40px;" />
                                </v-col>
                                <v-col cols="12" class="">
                                    {{p[1]}} {{pl[p[1]-1].team}} ({{pl[p[1]-1].seed}}) <input height="20" class="float-right" style="border: solid thin #888888;width:40px;" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "Com",
    components: {},
    data() {
      return {
        pools:[],
        teams: [
          "Elle/Sienna",
          "Laney/Savanah",
          "Megan/Hadley",
          "Haley/Tessa",
          "Aubrey/Kyana",
          "Cayden/Lilee",
          "Taryn/Haven",
          "Elka/Mia",
          "Fred/Jen",
          "Taryn/Haven",
          "Elka/Mia"
        ],
        plngth:4,
        plcnt: 1,
      }
    },
    created(){
      this.CPools(this.teams)
    },
    computed: {
      ...mapState(['icons']),
    },
    methods: {
      ...mapActions(['get', 'post']),
      Pool(pool) {
        let ln = pool.length;
        let rounds = []
        switch (ln) {
          case 2:
            rounds = [[1,2]]
            break;
          case 3:
            rounds = [[1,3],[2,3],[1,2]]
            break;
          case 4:
            rounds = [[1, 4], [2, 3], [4, 2], [1, 3], [3, 4], [1, 2]];
            break
          case 5:
            rounds = [[4, 2], [5, 1], [2, 5], [3, 4], [5, 3], [1, 2], [3, 1], [4, 5], [1, 4], [2, 3]];
            break;
          case 6:
            rounds = [[2, 1], [3, 6], [4, 5], [3, 4], [6, 1], [2, 5], [6, 4], [2, 3], [1, 5], [4, 1], [5, 3], [6, 2], [5, 6], [1, 3], [4, 2]]
            break;
          default:
            break;
        }
        return rounds;
      },
      CPools(teams){
        if(!this.plngth)return//change to pool length
        let pools = []
        for( let i = 0; i<this.plcnt; i++){ //wrong logic here...
          pools.push([])
        }
        console.log(pools)
        let ln = teams.length
        for(let i =0; i <teams.length; i++){
          for(let y=0; y<pools.length; y++){
            if(y){
              i++
            }
            if(teams[i]){
              let b = {seed:i+1,team:teams[i]}
              pools[y].push(b)
              console.log('I',i,y)
            }
          }
        }
        this.pools=pools
      }
    }
  }

</script>

<style scoped>

</style>